export default "__VITE_ASSET__C_n$Q$0t__"